/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_TitleInputs */

const cs_franchise_title = /** @type {(inputs: Franchise_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franšíza`)
};

const en_franchise_title = /** @type {(inputs: Franchise_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Franchise`)
};

/**
* | output |
* | --- |
* | "Franchise" |
*
* @param {Franchise_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_title = /** @type {((inputs?: Franchise_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_title(inputs)
	return cs_franchise_title(inputs)
});